'use es6';

import enviro from 'enviro';
import FeedbackLoader from 'feedback-loader';
import { jsx as _jsx } from "react/jsx-runtime";
export const Surveys = {
  LP_STARTER_BETA: 'LP_STARTER_BETA',
  BLP_BETA: 'BLP_BETA',
  CI_TOPIC_SUGGESTIONS: 'CI_TOPIC_SUGGESTIONS'
};
const DELAY_FOR_ALWAYS_VISIBLE_SURVEY = 3000;

// Post-publish CSAT survey shown after new publish/schedule of a landing page
// (Note, this is same survey also shown in the content-detail-ui `/published` route the editor
// redirects to)
//
// QA:    https://app.hubspotqa.com/feedback/100765651/satisfaction/9/submissions/all
// PROD:  https://app.hubspot.com/feedback/53/satisfaction/57/submissions/all
const PAGE_EXPERIENCE_CSAT_SURVEY_ID = enviro.isQa() ? 9 : 57;
const PERCENTAGE_OF_USERS_TO_SHOW_SURVEY = 0.1;

// LP Starter feedback survey always visible in the editor for beta feedback
//
// QA:    https://app.hubspotqa.com/feedback/100765651/satisfaction/22/submissions/all
// PROD:  https://app.hubspot.com/feedback/53/satisfaction/95/submissions/all

// BLP Starter feedback survey always visible in the editor for BLP
//
// QA: https://app.hubspotqa.com/feedback/100765651/satisfaction/151/submissions/all
// Prod: https://app.hubspot.com/feedback/53/satisfaction/480/submissions/all

// Blog Post feedback survey
//
// QA: https://app.hubspotqa.com/feedback/100765651/satisfaction/233/submissions/all
// Prod: https://app.hubspot.com/feedback-editor/53/satisfaction/748/submissions/all

// Blog Post DND feedback survey
//
// QA: https://app.hubspotqa.com/feedback/100765651/satisfaction/233/submissions/all
// Prod: https://app.hubspot.com/feedback/53/satisfaction/838/submissions

const SurveyOptions = {
  [Surveys.LP_STARTER_BETA]: {
    id: enviro.isQa() ? 22 : 95,
    delay: DELAY_FOR_ALWAYS_VISIBLE_SURVEY
  },
  [Surveys.BLP_BETA]: {
    id: enviro.isQa() ? 151 : 480,
    delay: DELAY_FOR_ALWAYS_VISIBLE_SURVEY
  },
  [Surveys.CI_TOPIC_SUGGESTIONS]: {
    id: enviro.isQa() ? 328 : 980,
    delay: 30000
  }
};
const debugLog = (...message) => {
  if (enviro.debug('CMS_PAGE_CSAT_SURVEY')) {
    console.log(...message);
  }
};
export const showThrottledPostPagePublishCsatSurvey = (retry = 0) => {
  if (window.hsFeedback && window.hsFeedback.loadSurvey) {
    // TODO, move this code to a shared content lib so it can be used by content-detail-ui and
    // the editor? (plus the PERCENTAGE_OF_USERS_TO_SHOW_SURVEY too?)

    const notThrottled = Math.random() < PERCENTAGE_OF_USERS_TO_SHOW_SURVEY;
    if (notThrottled) {
      debugLog(`Loading CSAT survey: ${PAGE_EXPERIENCE_CSAT_SURVEY_ID}`);
      window.hsFeedback.loadSurvey('CSAT', PAGE_EXPERIENCE_CSAT_SURVEY_ID);
    } else {
      debugLog(`Throttled CSAT survey: ${PAGE_EXPERIENCE_CSAT_SURVEY_ID}`);
    }
  } else if (retry < 5) {
    debugLog(`Feedback client not available, retrying: ${retry + 1}`);
    setTimeout(() => {
      showThrottledPostPagePublishCsatSurvey(retry + 1);
    }, 2000);
  } else {
    debugLog(`Feedback client still not available, giving up`);
  }
};
export const renderFeedbackLoader = survey => {
  // Load the feedback loader on delay, since we won't actually need it until after a publish
  const normalDelayForPostPublishSurvey = 10000;
  const activeSurvey = SurveyOptions[survey] || {};
  const {
    id,
    delay
  } = activeSurvey;
  const delayMs = delay || normalDelayForPostPublishSurvey;
  const handleFeedbackClientLoad = feedbackClient => {
    if (id) {
      debugLog(`Feedback client loaded, triggering ${survey}: ${id}`);
      feedbackClient.loadSurvey('CSAT', id);
    } else {
      debugLog('Feedback client loaded');
    }
  };
  return /*#__PURE__*/_jsx(FeedbackLoader, {
    delayMs: delayMs,
    onClientLoad: handleFeedbackClientLoad
  });
};